import React from 'react';
import Icon from './Icon';
import createLink from "../../libs/createLink";
import {useNavigate} from "react-router-dom";

const replaceTitleByHash = (title) =>{
    if(title){
        if(title.charAt(0) === "#"){
            title = title.slice(1);
        }
        title = title.charAt(0).toUpperCase() + title.slice(1);
        let re = new RegExp(/([ |\-|_]+)/, 'g');
        title = title.replace(re, '');
        title = `#${title}`;
    }
    return title;
}

const TagList = ({
        className = "",
        tags = [],
        type = "",
        owner = {},
        enableRemove = false,
        removeTags = () =>{},
        addTags = () =>{}
    }) => {
    const navigate = useNavigate();
    return (
        <div className={`tag-list row wrap ${className}`}>
            {tags.map((tag, index) => {
                tag.title = replaceTitleByHash(tag.title);
                let link  = createLink(type, {tag : tag, slug : owner && owner.slug});
                return(
                <div className="tag" key={index}>
                    <div key={index}>
                        {tag.slug && tag.slug !== '' ?
                            <div className={"cursor-pointer"} onClick={()=>navigate(link)} key={index}>{tag.title}</div> :
                            <div key={index}>{tag.title}</div>}
                    </div>
                    {enableRemove && (
                        <span onClick={() => removeTags(index, tag._id)}><Icon type="close"/></span>)}
                    {type === "addTags" && (
                        <span onClick={() => addTags(index, tag._id)}><Icon type="plus"/></span>)}
                </div>
            )})}
        </div>
    )
};

export default TagList;